(function ($) {
  DJ.addBehavior('formsInit', '.product-filters, .contact-form, .search-grid-form-filters, .job-application-form', {
    attach: function () {
      const formWrapper = this;
      const checkboxes = formWrapper.querySelectorAll('input[type="checkbox"]');
      const select = formWrapper.querySelectorAll('select');
      const file = formWrapper.querySelectorAll('input[type="file"]');
      let optionWrapNative = false;

      /**
       * Place label above the select value if chosen anything but 'all'.
       * @param selectElement
       *  Element object.
       */
      const moveSelectLabel = (selectElement) => {
        if (selectElement.value === 'All') {
          $(selectElement).closest('.js-form-item').addClass('js-form-item--value-all');
        } else {
          $(selectElement).closest('.js-form-item').removeClass('js-form-item--value-all');
        }
      };

      // For the contact/application form use the native select list
      // for correct native validation work.
      if (formWrapper.classList.contains('contact-form') || formWrapper.classList.contains('job-application-form')) {
        optionWrapNative = true;
      }

      // Label move behavior for the selects on the search page.
      if (formWrapper.classList.contains('search-grid-form-filters')) {
        const introBlock = document.querySelector('.intro-block');
        const introBlockClass = 'intro-block--with-search-form-filters';
        const elementsArr = Array.prototype.slice.call(select);

        if (introBlock) {
          introBlock.classList.add(introBlockClass);
        }

        elementsArr.forEach((e) => {
          moveSelectLabel(e);

          e.addEventListener('change', () => {
            moveSelectLabel(e);
          });
        });
      }

      /**
       * jcf init.
       */
      jcf.replace(checkboxes, 'Checkbox');
      jcf.replace(select, 'Select', {
        wrapNative: optionWrapNative,
        fakeDropInBody: false,
        useCustomScroll: false,
        maxVisibleItems: 5
      });
      jcf.replace(file, 'File', {
        buttonText: '',
        placeholderText: ''
      });

      /**
       * After ajax complete re-init checkboxes.
       */
      jQuery(document).ajaxComplete(() => {
        const elementsToUpdateHolder = document.querySelector('.contact-form');
        const elementsToUpdate = elementsToUpdateHolder ? elementsToUpdateHolder.querySelectorAll('input[type="checkbox"]') : false;

        jcf.replace(elementsToUpdate, 'Checkbox');
      });

      /**
       * On submit scroll to the invalid element taking into account header height.
       */
      const delay = 0;
      const form = formWrapper.querySelector('form');
      const headerElement = document.querySelector('.header');
      const headerHeight = headerElement ? headerElement.offsetHeight : 0;
      const invalidInFocusClass = 'invalid--in-focus';

      if (form) {
        form.addEventListener('invalid', function (e) {
          $(e.target).addClass('invalid');

          const elementWithError = formWrapper.querySelector('.invalid');

          if (!elementWithError.classList.contains(invalidInFocusClass)) {
            elementWithError.classList.add(invalidInFocusClass);

            if ($(elementWithError).closest('.jcf-select')) {
              $(elementWithError).closest('.jcf-select').addClass(invalidInFocusClass);
            }
          }

          $('html, body').animate({ scrollTop: $(elementWithError).offset().top - (headerHeight + 20) }, delay);
        }, true);

        /**
         * On form element blur remove invalid classes.
         */
        form.addEventListener('blur', function (e) {
          $(e.target).removeClass('invalid');
          $(e.target).removeClass(invalidInFocusClass);

          if ($(e.target).closest('.jcf-select')) {
            $(e.target).closest('.jcf-select').removeClass(invalidInFocusClass);
          }
        }, true);
      }
    }
  });
})(jQuery);
